import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import AppHeader from '@/components/AppHeader.vue'
import '@/plugins/shipLoading'
import '@/plugins/lazyImg'

// Vant 组件按需引入
import {
  Toast,
  Button,
  Field,
  Form,
  Icon,
  Image as VanImage,
  Loading,
  Overlay,
  PullRefresh,
  List,
  Cell,
  CellGroup,
  Popup,
  Picker,
  ActionSheet,
  Dialog,
  Stepper,
  Tag,
  Empty,
  Search,
  Tabs,
  Tab,
  NavBar,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  ImagePreview
} from 'vant'
import 'vant/lib/index.css'

// 注册 Vant 组件
const vantComponents = [
  Toast, Button, Field, Form, Icon, VanImage, Loading, Overlay,
  PullRefresh, List, Cell, CellGroup, Popup, Picker, ActionSheet,
  Dialog, Stepper, Tag, Empty, Search, Tabs, Tab, NavBar,
  Tabbar, TabbarItem, Swipe, SwipeItem, ImagePreview
]
vantComponents.forEach(comp => Vue.use(comp))
Vue.component('app-header', AppHeader)
Vue.mixin({
  data() {
    return {
      pullRefreshing: false,
    }
  },
  activated() {
    if (typeof this.onRefresh === 'function') {
      this._bindPullRefresh()
    }
  },
  deactivated() {
    if (typeof this.onRefresh === 'function') {
      this._unbindPullRefresh()
    }
  },
  mounted() {
    if (typeof this.onRefresh === 'function') {
      this._bindPullRefresh()
    }
  },
  beforeDestroy() {
    if (typeof this.onRefresh === 'function') {
      this._unbindPullRefresh()
    }
  },
  methods: {
    _createPullTip() {
      if (this._pullTip) return
      const tip = document.createElement('div')
      tip.style.cssText = `
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%) translateY(-100%);
        background: rgba(242, 201, 76, 0.15);
        border: 1px solid rgba(242, 201, 76, 0.4);
        color: #f2c94c;
        font-size: 13px;
        font-weight: 600;
        padding: 8px 20px;
        border-radius: 0 0 20px 20px;
        z-index: 9999;
        transition: transform 0.2s ease;
        letter-spacing: 0.04em;
        white-space: nowrap;
        backdrop-filter: blur(8px);
      `
      document.body.appendChild(tip)
      this._pullTip = tip
    },
    _updatePullTip(dist) {
      if (!this._pullTip) return
      const progress = Math.min(dist / 80, 1)
      const text = progress >= 1
        ? (this.$t ? this.$t('common.releaseRefresh') : 'Release to refresh')
        : (this.$t ? this.$t('common.pullRefresh') : 'Pull to refresh')
      this._pullTip.textContent = text
      this._pullTip.style.transform = `translateX(-50%) translateY(${progress * 100 - 100}%)`
    },
    _hidePullTip() {
      if (!this._pullTip) return
      this._pullTip.style.transform = 'translateX(-50%) translateY(-100%)'
    },
    _removePullTip() {
      if (this._pullTip) {
        document.body.removeChild(this._pullTip)
        this._pullTip = null
      }
    },
    _bindPullRefresh() {
      this._unbindPullRefresh()
      this._createPullTip()
      this._startY = 0
      this._pulling = false
      this._onTouchStart = (e) => {
        if (window.scrollY > 0) return
        this._startY = e.touches[0].clientY
        this._pulling = true
      }
      this._onTouchMove = (e) => {
        if (!this._pulling) return
        const dist = e.touches[0].clientY - this._startY
        if (dist > 0) this._updatePullTip(dist)
      }
      this._onTouchEnd = async (e) => {
        if (!this._pulling) return
        this._pulling = false
        const dist = e.changedTouches[0].clientY - this._startY
        this._hidePullTip()
        if (dist > 80) {
          this.pullRefreshing = true
          await this.onRefresh()
          this.pullRefreshing = false
        }
      }
      window.addEventListener('touchstart', this._onTouchStart, { passive: true })
      window.addEventListener('touchmove', this._onTouchMove, { passive: true })
      window.addEventListener('touchend', this._onTouchEnd, { passive: true })
    },
    _unbindPullRefresh() {
      this._hidePullTip()
      this._removePullTip()
      if (this._onTouchStart) {
        window.removeEventListener('touchstart', this._onTouchStart)
        window.removeEventListener('touchmove', this._onTouchMove)
        window.removeEventListener('touchend', this._onTouchEnd)
        this._onTouchStart = null
        this._onTouchMove = null
        this._onTouchEnd = null
      }
    },
  },
})
// 挂载 Toast 到全局，方便 this.$toast 调用
// forbidClick: false 避免 toast 触发 body class 变化引起 iOS 滚动跳动
Toast.setDefaultOptions({ forbidClick: false, duration: 2500 })
Vue.prototype.$toast = Toast

// 全局样式
import './styles/global.scss'


Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')